'use client';
import React, { useState } from 'react';
import { FileBarChart2, Printer, Download, ChevronDown, Calendar } from 'lucide-react';

const MONTHS = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December',
];

export default function ReportHeader() {
  const [selectedMonth, setSelectedMonth] = useState('May 2026');
  const [showPicker, setShowPicker] = useState(false);

  return (
    <div className="flex flex-col sm:flex-row sm:items-start justify-between gap-4">
      <div className="flex items-start gap-3">
        <div className="p-2.5 rounded-xl bg-primary/10">
          <FileBarChart2 size={20} className="text-primary" />
        </div>
        <div>
          <h1 className="text-2xl font-600 text-foreground" style={{ fontWeight: 600 }}>
            Monthly Accountability Report
          </h1>
          <p className="text-sm text-muted-foreground mt-0.5">
            Northfield Secondary School &mdash; {selectedMonth} &mdash; Generated: 14 May 2026
          </p>
        </div>
      </div>
      <div className="flex items-center gap-2 flex-wrap">
        {/* Month Picker */}
        <div className="relative">
          <button
            type="button"
            onClick={() => setShowPicker(!showPicker)}
            className="flex items-center gap-2 px-3 py-2 rounded-lg border border-border bg-card text-sm font-500 text-foreground hover:bg-muted transition-colors"
            style={{ fontWeight: 500 }}
          >
            <Calendar size={14} className="text-muted-foreground" />
            {selectedMonth}
            <ChevronDown size={14} className="text-muted-foreground" />
          </button>
          {showPicker && (
            <div className="absolute right-0 top-full mt-1 z-20 bg-card border border-border rounded-xl shadow-lg p-2 grid grid-cols-3 gap-1 w-56 fade-in">
              {MONTHS?.map((m) => (
                <button
                  key={`rpt-month-${m}`}
                  type="button"
                  onClick={() => { setSelectedMonth(`${m} 2026`); setShowPicker(false); }}
                  className={`text-xs px-2 py-1.5 rounded-lg font-500 transition-colors ${
                    selectedMonth?.startsWith(m) ? 'bg-primary text-primary-foreground' : 'text-foreground hover:bg-muted'
                  }`}
                  style={{ fontWeight: 500 }}
                >
                  {m?.slice(0, 3)}
                </button>
              ))}
            </div>
          )}
        </div>

        <button
          type="button"
          className="flex items-center gap-2 px-3 py-2 rounded-lg border border-border bg-card text-sm font-500 text-muted-foreground hover:text-foreground hover:bg-muted transition-colors"
          style={{ fontWeight: 500 }}
          title="Export monthly report as PDF"
        >
          <Download size={14} />
          Export PDF
        </button>

        <button
          type="button"
          className="flex items-center gap-2 px-4 py-2 rounded-lg bg-primary text-primary-foreground text-sm font-600 hover:bg-primary/90 transition-all duration-150 active:scale-95"
          style={{ fontWeight: 600 }}
          onClick={() => window.print()}
          title="Print the formatted monthly accountability report"
        >
          <Printer size={14} />
          Print Report
        </button>
      </div>
    </div>
  );
}